// extracted by mini-css-extract-plugin
module.exports = {"container":"Select--container--3a0g5","avatar":"Select--avatar--W8Ka5"};